import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@jem-open/jem-ui';
import { environment } from '../../../environment/environment';
import { DataTable } from '../../../components/DataTable';
import { EmptyState } from '../../../components/EmptyState';

/**
 * @summary AdvanceBatchItemsModal component
 *
 * @param {Props} props
 * @component
 */
const AdvanceBatchItemsModal = (props) => {
  const [state, setState] = useState({
    batchAdvances: null,
    loading: true,
  });
  const { toggleBatchItemsModal, handleShowBatchItemsModal, activeBatch } =
    props;

  const getAdvances = () => {
    setState((prev) => ({ ...prev, loading: true }));
    axios
      .get(`${environment.baseUrl}/advance_batch/${activeBatch.id}/report`)
      .then((res) => {
        setState((prev) => ({
          ...prev,
          batchAdvances: res.data,
          loading: false,
        }));
      })
      .catch(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  };

  useEffect(() => {
    getAdvances();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { key: 'id', label: 'ID', width: '80px' },
    { key: 'amount_requested', label: 'Amount Requested' },
    { key: 'fee', label: 'Fee' },
    { key: 'status', label: 'Status' },
    { key: 'reason', label: 'Reason' },
    { key: 'source_type', label: 'Source Type' },
    { key: 'source_id', label: 'Source ID' },
  ];

  const emptyState = (
    <EmptyState
      icon="fas fa-layer-group"
      message="This batch has no linked advances"
    />
  );

  return (
    <Dialog
      open={toggleBatchItemsModal}
      onOpenChange={(next) => {
        if (!next) handleShowBatchItemsModal();
      }}>
      <DialogContent className="flex max-h-[85vh] flex-col sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Advance Batch Items</DialogTitle>
        </DialogHeader>

        <div className="min-h-0 flex-1 overflow-y-auto">
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={Array.isArray(state.batchAdvances) ? state.batchAdvances : []}
              loading={state.loading}
              emptyState={emptyState}
              skeletonRows={6}
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleShowBatchItemsModal}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

AdvanceBatchItemsModal.defaultProps = {
  activeBatch: null,
};

AdvanceBatchItemsModal.propTypes = {
  toggleBatchItemsModal: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    .isRequired,
  handleShowBatchItemsModal: PropTypes.func.isRequired,
  activeBatch: PropTypes.shape({
    id: PropTypes.string,
  }),
};

export default AdvanceBatchItemsModal;
